import { fetcher } from "@certn/api";
import { showToast } from "@certn/cascadia";
import * as Sentry from "@sentry/react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { useApplicationFormContext } from "../../../ApplicationFormContext";
import { OneIdLayoutContext } from "../../../layouts/OneIdLayoutContext";

export function useBiometricIdOptOutHandler() {
  const { t } = useTranslation();
  const { caseId } = useApplicationFormContext();
  const { mutate, handleChange } = useContext(OneIdLayoutContext);

  const changeBiometricIdOptOut = async (value: boolean) => {
    try {
      await fetcher.submit(
        `/api/internal/applicant/case/${caseId}/update-biometric-id-verification-opt-out/`,
        { biometric_id_verification_opt_out: value }
      );
      mutate();
      handleChange("biometric_id_verification_opt_out", value);
    } catch (e) {
      console.error("Error changing value of biometric ID opt out", e);
      showToast(t("Something went wrong, try again"), {
        type: "error",
      });
      Sentry.captureException(e);
    }
  };
  return changeBiometricIdOptOut;
}
